// src/api/index.js

import client from './internal/httpClient';

// 示例请求函数，你可以根据自己的需求修改和添加
export function ping() {
  return client.get("/ping/index");
}
export const fetchLogs = (data) => {
  return client.post('/logs',data);
};
export const fetchAnalays = () => {
  return client.get('/admin/analysis');
};
export const fetchPosts = () => {
  return client.get('/posts');
};
export const fetchLinks = (data) => {
  // 后端 /links 从 php://input 读 website，必须用 POST body 传参，否则 400。
  return client.post('/links', data);
};
export const editLinks = (data) => {
  return client.post('/editlink',data);
};
export const getUser = () => {
  return client.get('/userinfo');
};
export const getActiveAnalysis = () => {
  return client.get('/admin/activeanalysis');
};
